<template>
  <div class="c-input c-input--group">
    <input
      type="text"
      name="input_text"
      :value="value"
      :placeholder="placeholder"
      :class="{
        'c-input__background': background,
        'c-input__background--error': error
      }"
      class="c-input__text"
      @input="input"
      @keypress.enter="onSearch"
      autocomplete="on"
    />
    <button type="submit" class="c-input__button" @click="onSearch">
      <icon name="action_search" />
      <span class="c-input__searchlabel">検索</span>
    </button>
  </div>
</template>

<script>
import Icon from "@/common/components/icons/IconKeywordSearch.vue";

export default {
  components: {
    Icon
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "キーワード検索"
    },
    background: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    input(e) {
      this.$emit("input", e.target.value);
    },
    onSearch() {
      this.$emit("onSearch");
    }
  }
};
</script>

<style lang="scss" scoped>
.c-input {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  .c-input__text {
    border-radius: 0.5rem;
  }

  .c-input__text:first-child {
    height: 3rem;
  }

  input {
    padding: 0.75rem 1rem;
    width: 100%;
    border: 1px solid #cacccf;
    color: #1f2021;
    line-height: 1.8;
    overflow: hidden;
  }

  .c-input__background {
    background: #f4f5f6 !important;
  }

  .c-input__button {
    border-radius: 0.5rem;
    width: 110px;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    margin-left: 1.5rem;
    flex-shrink: 0;
    min-width: 5em;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #da291c;
    color: #fff;
    height: 3rem;
  }
}
</style>
